import Service from "../../AuthService";
const ProductOverview = {
    getProductOverview(page,data) {
        return Service.get("/overview-product?page="+page+
            '&start_date='+data.start_date+
            '&end_date='+data.end_date +
            '&product_sku='+data.product_sku +
            '&product_type_id='+data.product_type_id
        );
    },
};
export default ProductOverview;
